<template>
  <div class="flex-col justify-start items-center relative page">
    <div class="flex-col group">
      <div class="flex-row">
        <img
          @click="$router.back()"
          class="image"
          src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=73da474f9f0a9d2a13c183e0f2ed8f88.png"
        />
        <span class="self-start text ml-119">修改脚本</span>
      </div>
      <div class="flex-col group_2 mt-37">
        <div class="flex-col justify-start section_2">
          <div class="flex-col items-start group_3">
            <span class="font text_2">
              宝爸宝妈们，好消息来啦！2024年学平险保障范围全面扩大啦！
              <br />
            </span>
            <span class="font text_3">
              孩子上学，安全和健康是头等大事。学平险一直是家长们为孩子保驾护航的“小能手”，如今它变得更强大了！
              <br />
            </span>
            <span class="font text_4">
              今年的学平险不仅涵盖了意外伤害、疾病医疗等常见保障，还新增了许多实用的保障内容。比如，一些产品增加了校园内意外事故的赔付范围，甚至对一些特殊疾病也有了更全面的保障。无论是小磕小碰，还是突发疾病，都能给孩子更贴心的守护。
              <br />
            </span>
            <span class="font text_7">
              更让人惊喜的是，保障升级的同时，保费并没有大幅增加，性价比超高！这对于家长们来说，无疑是最大的福音。
              <br />
            </span>
            <span class="font text_8">
              孩子的成长路上，风险处无不在。2024年学平险的升级，就像给孩子的校园生活加了一道“安全锁”。家长们，赶紧了解一下，为孩子选择一份更全面的保障吧！
            </span>
          </div>
        </div>
        <div class="flex-col justify-start items-center text-wrapper_2 mt-23"><span class="text_9">开始拍摄</span></div>
      </div>
    </div>
    <div class="flex-col justify-start items-center section pos">
      <div class="flex-col section_3">
        <span class="self-start font_2 text_5">脚本中存在违规信息</span>
        <div class="flex-col justify-start items-start self-stretch text-wrapper mt-25">
          <span class="font_2 text_6">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {};
    },

    methods: {},
  };
</script>

<style scoped lang="less">
  .ml-119 {
    margin-left: 119px;
  }
  .mt-37 {
    margin-top: 37px;
  }
  .mt-23 {
    margin-top: 23px;
  }
  .mt-25 {
    margin-top: 25px;
  }
  .page {
    padding: 14px 0 43px;
    background-color: rgb(17, 17, 17);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      width: 346px;
      .image {
        border-radius: 5px;
        width: 24px;
        height: 24px;
      }
      .text {
        color: rgb(255, 255, 255);
        font-size: 18px;
        font-family: 思源黑体;
        font-weight: 700;
        line-height: 17px;
      }
      .group_2 {
        padding-left: 12px;
        .section_2 {
          padding: 23px 0 58px;
          background-color: rgba(108, 108, 108, 0.5);
          border-radius: 20px;
          .group_3 {
            margin: 0 13px;
            padding-bottom: 138px;
            overflow: hidden;
            width: 308px;
            height: 570px;
            .font {
              font-size: 16px;
              font-family: 思源黑体;
              letter-spacing: 2px;
              line-height: 19px;
              color: rgb(249, 249, 249);
            }
            .text_2 {
              width: 309.5px;
            }
            .text_3 {
              margin-top: 4px;
              width: 320.5px;
            }
            .text_4 {
              margin-top: 4px;
              width: 321px;
            }
            .text_7 {
              margin-top: -6px;
              width: 320.5px;
            }
            .text_8 {
              margin-top: 4px;
              width: 329px;
            }
          }
        }
        .text-wrapper_2 {
          padding: 12px 0 18px;
          background-color: rgb(85, 239, 227);
          border-radius: 16px;
          overflow: hidden;
          width: 334px;
          .text_9 {
            color: rgb(17, 17, 17);
            font-size: 22px;
            font-family: Barlow;
            font-weight: 600;
            line-height: 20.5px;
            letter-spacing: 2px;
          }
        }
      }
    }
    .section {
      padding: 252px 0 459px;
      background-color: rgba(0, 0, 0, 0.7);
      .section_3 {
        padding: 35px 8px 0;
        background-color: rgb(234, 233, 233);
        border-radius: 20px;
        .font_2 {
          font-size: 18px;
          font-family: 微软雅黑;
          line-height: 17.5px;
          color: rgba(0, 0, 0, 0.8);
        }
        .text_5 {
          margin-left: 12px;
        }
        .text-wrapper {
          padding: 18px 0;
          width: 241px;
          border-top: solid 1px rgba(0, 0, 0, 0.2);
          .text_6 {
            margin-left: 89px;
            line-height: 17.5px;
          }
        }
      }
    }
    .pos {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
</style>
